<template lang="pug">
.application-factoring-third-party-list.card
  .card-header {{ $t('title') }}
    button.btn.btn-link.fa-pull-right.py-0.animated.fadeIn(
      :title         = '$t("common:add")'
      @click.prevent = 'showAddThirdParty = true'
    ): i.fas.fa-user-plus.fa-lg
  .card-body
    fi-table(
      :fields      = 'fields'
      :items       = 'thirdPartyList'
      :empty-label = '$t("notFound")'
    )
      template(#default = '{ items }')
        application-factoring-third-party-list-item(
          v-for        = '(item, index) in items'
          :key         = 'index'
          :product     = 'product'
          :application = 'sourceData'
          :third-party = 'item'
          @edit        = '$emit("edit", { ...$event, index })'
          @remove      = '$emit("remove", { ...$event, index })'
        )
  application-factoring-third-party-modal(
    v-model      = 'showAddThirdParty'
    :product     = 'product'
    :source-data = 'sourceData'
    :loader      = '$vueLoading.isLoading(`factoring:application:thirdParty:save`)'
    @submit      = '$emit("create", $event)'
  )
</template>


<script>
import FiTable from '@/components/FiTable'
import ApplicationFactoringThirdPartyModal
  from '@/views/applications/ApplicationFactoring/ApplicationFactoringThirdPartyModal'
import ApplicationFactoringThirdPartyListItem
  from '@/views/applications/ApplicationFactoring/ApplicationFactoringThirdPartyListItem'

export default {
  name: 'application-factoring-third-party-list',

  components: { ApplicationFactoringThirdPartyListItem, ApplicationFactoringThirdPartyModal, FiTable },

  props: {
    thirdPartyList: {
      type: Array,
      default: () => []
    },
    sourceData: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },

  i18nOptions: {},

  data: () => ({
    showAddThirdParty: false
  }),

  computed: {
    fields () {
      return [
        {
          key: 'customerName',
          label: this.$t('customerName')
        },
        {
          key: 'limit',
          label: this.$t('limit'),
          class: 'money'
        },
        {
          key: 'advanceRate',
          label: this.$t('advanceRate')
        },
        {
          key: 'invoiceLength',
          label: this.$t('invoiceLength')
        },
        {
          key: 'interestRate',
          label: this.$t('interestRate')
        },
        {}
      ]
    }
  }
}
</script>


<i18n>
en:
  title:         "Third parties"
  customerName:  "Customer name"
  limit:         "Limit"
  advanceRate:   "Advance rate"
  invoiceLength: "Invoice length (days)"
  interestRate:  "Interest rate"
  notFound:      "No third parties"
et:
  title:         "Third parties"
  customerName:  "Customer name"
  limit:         "Limit"
  advanceRate:   "Advance rate"
  invoiceLength: "Invoice length (days)"
  interestRate:  "Interest rate"
  notFound:      "No third parties"
ru:
  title:         "Third parties"
  customerName:  "Customer name"
  limit:         "Limit"
  advanceRate:   "Advance rate"
  invoiceLength: "Invoice length (days)"
  interestRate:  "Interest rate"
  notFound:      "No third parties"
</i18n>
